import { useSavedSearches } from '~/context/common/SavedSearchesContext';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';

export default function useLoadSaveSearchNudge() {
  const isDealership = useIsDealershipPage();
  const savedSearches = useSavedSearches();

  return !isDealership && savedSearches.length === 0;
}
